(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 9208:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(3287);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Redirect; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




/**
 * 指定したページにリダイレクトする
 */ var Redirect = function(param) {
    var redirectTo = param.redirectTo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        router.replace(redirectTo);
    }, [
        router,
        redirectTo
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        href: redirectTo,
        children: "".concat(window.origin).concat(redirectTo.pathname, " に移動しています...")
    });
};


/***/ }),

/***/ 3287:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);
/* harmony import */ var _libs_pathpida_$path__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9177);
/* harmony import */ var _ui_loading_loading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7532);
/* harmony import */ var _features_auth_redirect_redirect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9482);





var Home = function() {
    var ref = (0,_auth0_auth0_react__WEBPACK_IMPORTED_MODULE_1__/* .useAuth0 */ .D3)(), isLoading = ref.isLoading, isAuthenticated = ref.isAuthenticated;
    if (isLoading) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ui_loading_loading__WEBPACK_IMPORTED_MODULE_3__/* .Loading */ .g, {
            description: {
                type: "loadingAuth"
            },
            full: true
        });
    }
    // 未認証の場合、ログインページにリダイレクト
    if (!isAuthenticated) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_auth_redirect_redirect__WEBPACK_IMPORTED_MODULE_4__/* .Redirect */ .l, {
            redirectTo: _libs_pathpida_$path__WEBPACK_IMPORTED_MODULE_2__/* .pagesPath.login.$url */ .V.login.$url()
        });
    }
    // 認証済みの場合、受講生一覧ページにリダイレクト
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_features_auth_redirect_redirect__WEBPACK_IMPORTED_MODULE_4__/* .Redirect */ .l, {
        redirectTo: _libs_pathpida_$path__WEBPACK_IMPORTED_MODULE_2__/* .pagesPath.accounts.$url */ .V.accounts.$url()
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(9208); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);